module.exports = __webpack_public_path__ + "img/nofind.99396a55.png";